import { CustomerAddressDetails } from './customer-address-details.interface';
import { CustomerTelephoneDetails } from './customer-telephone-details.interface';

export interface CustomerDetails {
  billingAddress: CustomerAddressDetails;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  phone: CustomerTelephoneDetails;
  title?: string | null;
  personId?: string | null;
  isFormatted?: boolean; // Indicates if the address is formatted
}
